import React from "react";
import { Alert, Box, CircularProgress, Grid, Paper, Stack, Typography } from "@mui/material";
import { formatRseNumber } from "../reporteSaludEmergenciaUtils";

const QUALITY_ITEMS = [
  { key: "sexoSinDato", label: "Registros sin sexo" },
  { key: "edadInvalida", label: "Registros sin edad válida" },
  { key: "comunidadVacia", label: "Registros sin comunidad" },
  { key: "sinPatologiaValida", label: "Registros sin patología válida" },
  { key: "pendientes", label: "Registros pendientes" },
  { key: "rechazadasError", label: "Registros rechazados por error" },
  { key: "eliminadas", label: "Registros eliminados" },
  { key: "otros", label: "Registros con otro estado" },
];

const CalidadDatos = ({ data, loading, error }) => {
  const totals = data?.totals;
  const visibleItems = totals
    ? QUALITY_ITEMS.filter((item) => Object.prototype.hasOwnProperty.call(totals, item.key))
    : [];

  return (
    <Paper
      sx={{
        width: "100%",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        boxShadow: "0 8px 22px rgba(15, 23, 42, 0.06)",
        p: { xs: 2, md: 2.5 },
      }}
      data-testid="calidad-panel"
    >
      <Typography variant="h5" sx={{ fontWeight: 850 }}>Calidad de los datos</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: 2 }}>
        Indicadores agregados de completitud y estado de los registros.
      </Typography>

      {error ? (
        <Alert severity="error">No fue posible cargar esta información.</Alert>
      ) : loading ? (
        <Stack minHeight={150} alignItems="center" justifyContent="center" spacing={1.5}>
          <CircularProgress aria-label="Cargando calidad de datos" />
          <Typography color="text.secondary">Cargando calidad...</Typography>
        </Stack>
      ) : visibleItems.length === 0 ? (
        <Box minHeight={150} display="flex" alignItems="center" justifyContent="center" textAlign="center">
          <Typography color="text.secondary">No hay datos disponibles para este período.</Typography>
        </Box>
      ) : (
        <Grid container spacing={2}>
          {visibleItems.map((item) => (
            <Grid item xs={12} sm={6} lg={3} key={item.key}>
              <Box sx={{ borderLeft: "4px solid #008080", pl: 1.5, minHeight: 64 }}>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 700 }}>
                  {item.label}
                </Typography>
                <Typography variant="h4" sx={{ fontWeight: 900, mt: 0.5 }}>
                  {formatRseNumber(totals[item.key])}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      )}
    </Paper>
  );
};

export default CalidadDatos;
